import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(
    (theme: Theme) => ({
        /* Styles applied to the root element. */
        root: {
            display: 'flex',
            height: '56px',
            margin: '4px 0',
            padding: '0 16px',
            boxSizing: 'border-box',
            borderRadius: theme.shape.borderRadius / 2,
            borderWidth: 1,
            borderColor: 'inherit',
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
        outlinedPrimary: {
            borderColor: theme.palette.primary.main,
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
        outlinedSecondary: {
            borderColor: theme.palette.secondary.main,
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="default"`. */
        outlinedDefault: {
            borderColor: theme.palette.grey[400],
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */
        disabled: {
            borderColor: theme.palette.grey[200],
        },
    }),
    { name: 'MuiFormControlPaper' },
);

export default useStyles;
